(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeRemisecommerciale', TypeRemisecommerciale);

    TypeRemisecommerciale.$inject = ['$resource'];

    function TypeRemisecommerciale ($resource) {
        var resourceUrl =  'api/type-remisecommerciales/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
